'use client';

import { CSSProperties, FC } from 'react';
import GridCard from '@/components/recipes/grid-card/grid-card';
import Carousel from '@/components/ui/carousel/carousel';
import { useTranslation } from '@/providers/app-provider/app-provider';

export interface SimilarRecipeItem {
  id: string;
  title: string;
  description: string;
  image: string;
  href: string;
  cookingTime?: string;
}

interface SimilarRecipesProps {
  recipes: SimilarRecipeItem[];
  paddingStyle?: CSSProperties;
}

const SimilarRecipes: FC<SimilarRecipesProps> = ({ recipes, paddingStyle }) => {
  const { t } = useTranslation();
  if (recipes.length === 0) return null;

  return (
    <section className="container mx-auto" style={paddingStyle}>
      <h2 className="text-foreground mb-3 px-5 text-xl font-bold @md:mb-4 @md:px-0 @md:text-2xl">
        {t?.common.similarRecipes}
      </h2>
      <Carousel slides={recipes} options={{ align: 'start', slidesToScroll: 'auto' }}>
        {recipe => (
          <div
            key={recipe.id}
            className="shrink-0 grow-0 basis-[85%] @sm:basis-1/2 @lg:basis-1/3 @xl:basis-1/4"
          >
            <GridCard
              image={recipe.image}
              date=""
              title={recipe.title}
              description={recipe.description}
              href={recipe.href}
              cookingTime={recipe.cookingTime}
              titleHeadingLevel={3}
            />
          </div>
        )}
      </Carousel>
    </section>
  );
};

export default SimilarRecipes;
